import * as React from 'react';

import { SVGProps } from './type';

const EyeOpen = (props: SVGProps) => {
  const { color, width = 16, height = 17 } = props;
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 3.833c-4.204 0-6.244 3.789-6.606 4.539a.29.29 0 0 0 0 .256c.36.75 2.4 4.539 6.606 4.539 4.206 0 6.245-3.79 6.607-4.54a.29.29 0 0 0 0-.255c-.361-.75-2.401-4.539-6.607-4.539Z"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeOpen;
